import { Userbot } from "../interfaces"

/**
 * Бэк возвращает шаги отчёта в пагинированном конверте {items, total}
 * (исторически — просто массив). Нормализуем к массиву.
 */
export const normalizeReportSteps = (
  raw:
    | Userbot.ChainReportStep[]
    | Userbot.PageRes<Userbot.ChainReportStep>
    | null
    | undefined,
): Userbot.ChainReportStep[] => {
  if (Array.isArray(raw)) return raw
  return raw?.items ?? []
}
